import { create } from 'zustand/react';
import { persist, createJSONStorage } from 'zustand/middleware';
import { StateCreator } from 'zustand';
import { createFilterSetsSlice, FilterSetsSlice } from 'components/filter/advancedFilter/hooks/useFilterSetsStore';

/**
 * Generic persisted store factory (sessionStorage/localStorage/etc).
 * This helps avoid long URLs when storing complex data structures.
 *
 * @param createSlice - The slice creator function
 * @param storeName - Unique key for storage
 * @param getStorage - Storage provider (e.g. () => sessionStorage / () => localStorage)
 * @returns A zustand store that persists to the selected storage
 */
export function createPersistedStore<T>(
  createSlice: StateCreator<T, [], [], T>,
  storeName: string,
  getStorage: () => Storage
) {
  return create<T>()(
    persist(createSlice, {
      name: storeName,
      storage: createJSONStorage(getStorage),
    })
  );
}

export const useFilterSetsSessionStore = createPersistedStore<FilterSetsSlice>(
  createFilterSetsSlice,
  'filterSets',
  () => sessionStorage
);
